exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-archive-view-tsx": () => import("./../../../src/pages/archive-view.tsx" /* webpackChunkName: "component---src-pages-archive-view-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-lounge-tsx": () => import("./../../../src/pages/lounge.tsx" /* webpackChunkName: "component---src-pages-lounge-tsx" */)
}

